import React from "react";
import {
    ContentView,
    ContentProduct,
    ProductProps
} from "../../../../content/components";
import { ResizeMode, ViewType } from "../../../knobs/types";

export const ProductCircleListItem = React.memo((
    props: {
        viewsHeight: number,
        showCaption: boolean,
        showShadow?: boolean,
        viewsMargins: number,
    } & ProductProps
) => {
    return (
        <ContentView style={{
            height: props.viewsHeight,
            width: props.viewsHeight,
            borderRadius: props.viewsHeight / 2,
            marginRight: props.viewsMargins ? props.viewsMargins : 4,
            shadowOpacity: props.showShadow ? 0.9 : undefined,
            shadowRadius: props.showShadow ? 6 : undefined,
            overflow: 'hidden'
        }}>
            <ContentProduct
                id={props.id}
                viewType={ViewType.Circles}
                caption={''}
                textColor={props.textColor}
                textAlign={props.textAlign}
                showCaption={props.showCaption}
                placeholderImage={props.placeholderImage}
                showTextBackground={props.showTextBackground}
                fontWeight={props.fontWeight}
                imageResizeMode={props.imageResizeMode as ResizeMode}
                blurIntencity={props.blurIntencity}
                showPrice={props.showPrice}
            />
        </ContentView>
    );
})